const scrollWithOffset = (el) => {
  const vw = window.innerWidth;
  let yOffset;
  if (vw <= 1024) {
    yOffset = -108;
  } else if (vw <= 1440) {
    yOffset = -112;
  } else {
    yOffset = -144;
  }

  const y = el.getBoundingClientRect().top + window.scrollY + yOffset;
  window.scrollTo({ top: y, behavior: "smooth" });
};
export default scrollWithOffset;
